// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"f6bb49ac","763":"b76e31c7","775":"8b9c4464"}[chunkId] + ".chunk.js";
};